// @ts-expect-error - TS2305 - Module '"react-router-dom"' has no exported member 'LocationShape'.
import {Link, type LocationShape} from "react-router-dom";

import {
    markMinorConversions,
    type Conversion,
    type ConversionName,
    type MarkConversionT,
    type MinorConversionData,
} from "@khan/analytics-learning-time";

/**
 * Return whether the given path represents a page that is in the app shell.
 *
 * Most of our pages are, but this function helps us catch some exception cases.
 */
export const pathIsInShell = (path: string): boolean => {
    // External links are not in the shell.
    if (path.indexOf("//") >= 0) {
        return false;
    }

    // `javascript:void 0` is not in the shell, it's nothing!
    if (path.startsWith("javascript:")) {
        return false;
    }

    // The Official SAT Practice dashboard is not in the shell.
    if (path === "/mission/sat") {
        return false;
    }

    // The Official SAT Practice landing page is not in the shell.
    if (path === "/sat") {
        return false;
    }

    // Everything else is assumed to be in the shell!
    return true;
};

export const getLinkElement = (
    to = "",
    router?: any,
    forceServer?: boolean,
):
    | React.ComponentType<{
          readonly children?: React.ReactNode;
          readonly className?: string;
          readonly replace?: boolean;
          readonly to: string | LocationShape;
      }>
    | string => {
    if (!router || forceServer || !pathIsInShell(to)) {
        return "a";
    }

    return Link;
};

export const onClickWithMarkConversions = (
    markConversion: MarkConversionT,
    onClick?: (e: React.MouseEvent) => unknown,
    conversions?: ReadonlyArray<ConversionName | Conversion>,
    minorConversions?: ReadonlyArray<MinorConversionData>,
): ((e: React.MouseEvent) => void) => {
    return (e: React.MouseEvent) => {
        if (onClick) {
            onClick(e);
        }
        if (conversions) {
            for (const conversion of conversions) {
                if (typeof conversion === "string") {
                    markConversion({id: conversion});
                } else {
                    markConversion(conversion);
                }
            }
        }
        if (minorConversions) {
            markMinorConversions(minorConversions);
        }
    };
};
